import { combineReducers } from 'redux';
import commonStoreReducer from '../../../shared/components/react/CommonDataStore/reducer';
import * as Actions from '../actions/popularWidgetActionTypes';
import mainSocket from '../../../shared/services/mainSocketClass';

/**
 * Main Popular Widget reducer
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
function popularWidgetReducer(state = {events: []}, action) {

    switch (action.type) {
        case Actions.POPULAR_WIDGET_LOADING_SUCCESS: {
            return { ...state, events: action.events };
        }
        case Actions.POPULAR_WIDGET_START_LISTENING_FOR_WS_UPDATES: {
            mainSocket.subscribeForUpdates(action.events);

            return state;
        }
        case Actions.POPULAR_WIDGET_ERROR: {
            return { ...state, errorOccurred: action.errorOccurred };
        }
        default:
            return state;
    }
}

export default combineReducers({
    popularWidget: popularWidgetReducer,
    commonData: commonStoreReducer,
});
